import {
  COST_AGGREGATE_DASHBOARD,
  COST_DASHBOARD_LOOKUP,
  COST_DASHBOARD_SUMMARY,
  COST_DASHBOARD_REGION_SUMMARY,
  COST_DASHBOARD_RESOURCE_SUMMARY,
  COST_DASHBOARD_SPEND_TREND,
  SPEND_BREAKDOWN_SUMMARY,
  SPEND_BREAKDOWN_RESOURCE,
} from "../../config/service";
import {
  costDashboardAggregate,
  costDashboardLookup,
  costDashboardSummary,
  regionSummary,
  resourceSummary,
  spendTrend,
  spendBreakdownSummary,
  spendBreakdownResources,
} from "../factories/costDashboard";

export const costDashboardServices = (mock) => {
  const costDashboardResourceSummaryURL = new RegExp(
    `${COST_DASHBOARD_RESOURCE_SUMMARY}`
  );

  mock.onGet(costDashboardResourceSummaryURL).reply(async (config) => {
    const summaryData = resourceSummary();

    return [200, summaryData];
  });

  const costDashboardSpendBreakdownResourceURL = new RegExp(
    `${SPEND_BREAKDOWN_RESOURCE}`
  );

  mock.onGet(costDashboardSpendBreakdownResourceURL).reply(async (config) => {
    const completeQueryParamString = decodeURI(config.url).split("Filters=")[1];

    const decodedQueryParam = decodeURIComponent(
      completeQueryParamString
    ).split("&");

    const filterParams = JSON.parse(decodedQueryParam[0]);

    const offset = decodedQueryParam[2].split("=")[1];

    const summaryData = spendBreakdownResources(filterParams, offset);
    return [200, summaryData];
  });

  const costDashboardSpendBreakdownSummaryURL = new RegExp(
    `${SPEND_BREAKDOWN_SUMMARY}`
  );

  mock.onGet(costDashboardSpendBreakdownSummaryURL).reply(async (config) => {
    const completeQueryParamString = decodeURI(config.url).split("Filters=")[1];
    //sample completeQueryParamString {"StartDate":"2023-12-01","EndDate":"2024-01-11","SummaryType":"by-account"}&Limit=25&Offset=0

    const decodedQueryParam = decodeURIComponent(
      completeQueryParamString
    ).split("&");

    const filterParams = JSON.parse(decodedQueryParam[0]);

    const offset = decodedQueryParam[2].split("=")[1];
    const summaryData = spendBreakdownSummary(filterParams, offset);
    return [200, summaryData];
  });

  const costDashboardSpendTrendURL = new RegExp(
    `${COST_DASHBOARD_SPEND_TREND}`
  );

  mock.onGet(costDashboardSpendTrendURL).reply(async (config) => {
    const completeQueryParamString = decodeURI(config.url).split("Filters=")[1];
    const decodedQueryParam = decodeURIComponent(completeQueryParamString);

    const filterParams = JSON.parse(decodedQueryParam);

    const summaryData = spendTrend(filterParams.SummaryType);
    return [200, summaryData];
  });

  const costDashboardRegionSummaryURL = new RegExp(
    `${COST_DASHBOARD_REGION_SUMMARY}`
  );

  mock.onGet(costDashboardRegionSummaryURL).reply(async (config) => {
    const summaryData = regionSummary();

    return [200, summaryData];
  });

  const costDashboardSummaryURL = new RegExp(`${COST_DASHBOARD_SUMMARY}`);

  mock.onGet(costDashboardSummaryURL).reply(async (config) => {
    const completeQueryParamString = decodeURI(config.url).split("Filters=")[1];
    const decodedQueryParam = decodeURIComponent(completeQueryParamString);

    const filterParams = JSON.parse(decodedQueryParam);

    const summaryData = costDashboardSummary(filterParams.SummaryType);
    return [200, summaryData];
  });

  const costDashboardLookupURL = new RegExp(`${COST_DASHBOARD_LOOKUP}`);

  mock.onGet(costDashboardLookupURL).reply(async (config) => {
    const lookupData = costDashboardLookup();
    return [200, lookupData];
  });

  const costAggregateDashboardURL = new RegExp(`${COST_AGGREGATE_DASHBOARD}`);

  mock.onGet(costAggregateDashboardURL).reply(async (config) => {
    const agrregateData = costDashboardAggregate();
    return [200, agrregateData];
  });
};
